export default {
  metaDescription: 'TEF provides fabrication solutions for vessels, piping, heating equipment and more, plus maintenance and reconditioning services including retubing and re-shelling.',
  pageTitle: 'Services',
  expertise: {
    title: 'Our Expertise',
    description:
      '<strong>PT TOKKI ENGINEERING AND FABRICATION</strong> is committed to delivering high-quality products and excellent after-sales technical service from Indonesia to customers worldwide. As a specialized company in <strong>welded pressure vessels and sheet metal fabrication</strong>, we support industrial infrastructures across <strong>Oil & Gas, Petrochemicals, Pharmaceuticals, Fertilizer, Agricultural Chemicals, Power Plants, and Thermal Processing industries</strong>.',
  },
  fabricationSolutions: {
    heading: 'Fabrication Solutions',
    intro: 'We manufacture a wide range of industrial equipment, including:',
    cards: {
      vessels: { title: 'Pressure Vessels', desc: 'Reactors, tanks, towers, and heat exchangers.' },
      piping: { title: 'Prefabricated Piping Systems', desc: 'for efficient installation in petrochemical and pharmaceutical plants.' },
      heating: { title: 'Industrial Heating Equipment', desc: 'Muffles, radiant tubes, rotary kilns, trays, and baskets.' },
      etc: { title: 'Etc.', desc: 'All fabrication equipment.' },
    },
  },
  maintenance: {
    heading: 'Maintenance And Reconditioning',
    description:
      'In addition to new fabrication, we provide maintenance and reconditioning services, both in-house and on-site, to extend the life and performance of your equipment.',
    buttons: {
      retubing: 'Re-tubing for Heat Exchangers',
      pipelineRepairs: 'Pipeline Repairs & Servicing',
      onSiteMaintenance: 'On-site & Workshop-Based Maintenance',
      etc: 'Etc',
    },
  },
};
